import React from 'react';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Subtitle from 'Components/ComponentLibrary/Atoms/Text/Subtitle';
import LoadingIndicator from 'Components/UI/LoadingIndicator';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import useAffordance from 'Hooks/useAffordance';
import fr from 'facet-rest';
import Divider from 'Components/UI/Divider';
import { FDBox, FDHeadlineText } from '@facet-wealth/design';
import ModelChangeEvent, { metaOverrideSet as modelChangeEventMetaOverrideSet } from './ModelChangeEvent';

const useStyles = buildUseStyles('AccountPerformanceDashboard', (theme) => ({
  root: {
  },
  currentAllocation: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  metaFormInline: {
    padding: 0,
    backgroundColor: 'inherit',
  },
}));

export default function ModelChangeEventsPage() {
  const classes = useStyles();

  const { resource } = useMetaLayoutContext();

  const { collection: modelChangeEvents, loading, loadingError } = useAffordance(resource.relationship(fr.relationships.modelChangeEvents.name)?.link('related'));

  if (loadingError) {
    return <Box><Subtitle value="Could not load the information. Please retry later." /></Box>;
  }

  if (loading) {
    return <LoadingIndicator />;
  }

  return (
    <FDBox padding={'400'}>
      <MetaControlField attr="title" />
      <br />
      {modelChangeEvents.resources().list().map((modelChangeEvent, idx) => {
        const isFirstElement = idx === 0;
        const isSecondElement = idx === 1;
        return (
          <FDBox>
            <FDBox paddingY={isFirstElement ? 1 : 0}>
              <Box key={modelChangeEvent.id()}>
                {isFirstElement ? <>
                  <Box className={classes.currentAllocation}>
                    <FDHeadlineText size={'sm'} value={'Current Allocation'} />
                    <CheckCircleIcon color="secondary" fontSize="small" />
                  </Box>
                </> : null}
                {isSecondElement ? (
                  <FDBox paddingY={1}>
                    <FDHeadlineText size={'sm'} value={'Allocation History'} />
                  </FDBox>
                ) : null}
                <MetaFormInline
                  className={classes.metaFormInline}
                  resource={modelChangeEvent}
                  noIndividualSubmitButtons
                  layout={ModelChangeEvent}
                  metaOverrideSet={modelChangeEventMetaOverrideSet}
                />
              </Box>
            </FDBox>
            {isFirstElement ? (
              <FDBox paddingY={2}>
                <Divider />
              </FDBox>
            ) : null}
          </FDBox>
        );
      })}
    </FDBox>
  );
}
